<template>
  <div class="wk-brand-select">
    <crm-select
      :value="value"
      filterable
      remote
      :multiple="multiple"
      :disabled="disabled || (relativeCustomer && !customerId)"
      :clearable="clearable"
      :remote-method="queryCustomerName"
      :placeholder="placeholder"
      style="width: 100%;"
      @change="valueChange">
      <el-option
        v-for="(item, index) in options"
        :key="index"
        :label="!isEmptyValue(item.value) ? item.label || item.name : item "
        :value="getValue(item)" />
    </crm-select>
  </div>
</template>

<script>
import { isObject, isEmpty, isArray } from '@/utils/types'
import Emitter from 'element-ui/lib/mixins/emitter'
import { crmBrandsListAPI } from '@/api/premium/businessInfo'

export default {
  // 自定义字段库 搜索并选择品牌
  name: 'WkBrandSelect',

  components: {},

  mixins: [Emitter],

  props: {
    value: [String, Number, Array],
    disabled: Boolean,
    clearable: Boolean,
    placeholder: String,
    relativeCustomer: {
      type: Boolean,
      default: false
    },
    customer: {
      type: Array,
      default: () => []
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      options: []
    }
  },

  computed: {
    customerId() {
      if (this.customer && isArray(this.customer) && this.customer.length) {
        return this.customer[0].customerId;
      }
      return ''
    }
  },

  watch: {
    customerId: {
      immediate: true,
      handler(val) {
        if (this.relativeCustomer && val) {
          this.queryCustomerName(' ');
        } 
      }
    }
  },

  created() {
  },

  mounted() {
  },

  beforeDestroy() {},

  methods: {
    /**
     * @description: 品牌名称搜索
     * @param {*} params 搜索字符串
     * @return {*}
     */
    queryCustomerName(queryString) {
      if (queryString !== '') {
        const params = {
          page: 1,
          pageSize: 10,
          name: queryString,
        }
        if (this.relativeCustomer && this.customerId) {
          params.customerId = this.customerId
        }
        crmBrandsListAPI(params).then(res => {
          const reaData = res.data.list || []
          this.options = reaData.map(item => {
            return { label: item.name, value: item.name }
          })
        }).catch(() => {
        })
      } else {
        this.options = []
      }
    },

    /**
     * 选项值
     */
    getValue(item) {
      return !this.isEmptyValue(item.value) ? item.value : item
    },

    /**
     * 判断是空值
     */
    isEmptyValue(value) {
      return value === null || value == undefined
    },

    /**
     * 值更新
     */
    valueChange(value) {
      this.$emit('input', value)
      this.$emit('change', value)
      this.dispatch('ElFormItem', 'el.form.change', value)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
